import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Route, Switch, withRouter } from 'react-router-dom';
import taskGroupsActions from '../../store/task-groups/action-creators/index';
import TaskGroupIndex from './TaskGroupIndex';
import TaskGroupDetail from './TaskGroupDetail';
import TaskGroupEdit from './TaskGroupEdit';
import TaskGroupTaskAdd from './tasks/TaskGroupTaskAdd';
import TaskGroupTaskEdit from './tasks/TaskGroupTaskEdit';
import taskConfigActionCreators from "../../../admin-app/store/tasks-config/action-creators";

class TaskGroupContainer extends Component {
  // ----------------------
  // Lifecycle
  // ----------------------

  componentDidMount() {
    if(this.props.userContext.hasScope('admin')) {
      this.props.fetchConfigTaskGroups();
    }
    this.props.loadTaskGroupContainer();
  }

  componentWillUnmount() {
    this.props.unmountTaskGroupContainer();
  }

  render() {
    return this.props.userContext.hasScope('admin') ? (
      <Fragment>
        <Route
          component={TaskGroupTaskAdd}
          path="/admin/task-groups/:taskGroupGuid/add-task"
        />
        <Route
          component={TaskGroupEdit}
          path="/admin/task-groups/:taskGroupGuid/edit"
        />
        <Route
          component={TaskGroupTaskEdit}
          path="/admin/task-groups/:taskGroupGuid/edit-task/:taskGuid"
        />
        <Route component={TaskGroupIndex} exact path="/admin/task-groups" />
        <Route
          component={TaskGroupDetail}
          exact
          path="/admin/task-groups/:taskGroupGuid"
        />
      </Fragment>
    ) : (
      <Switch>
        <Route
          component={TaskGroupTaskAdd}
          path="/task-groups/:taskGroupGuid/add-task"
        />
        <Route
          component={TaskGroupEdit}
          path="/task-groups/:taskGroupGuid/edit"
        />
        <Route
          component={TaskGroupTaskEdit}
          path="/task-groups/:taskGroupGuid/edit-task/:taskGuid"
        />
        <Route component={TaskGroupDetail} path="/task-groups/:taskGroupGuid" />
        <Route component={TaskGroupIndex} path="/task-groups" />
      </Switch>
    );
  }
}

// ----------------------
// Redux Mappings
// ----------------------

const mapStateToProps = state => ({
  userContext: state.common.userContext,
});

const mapDispatchToProps = (dispatch) => {
  return {
    loadTaskGroupContainer: () => {
      return dispatch(taskGroupsActions.loadTaskGroupContainer());
    },
    unmountTaskGroupContainer: () => {
      return dispatch(taskGroupsActions.unmountTaskGroupContainer());
    },
    fetchConfigTaskGroups: () =>
      dispatch(taskConfigActionCreators.fetchConfigTaskGroups()),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TaskGroupContainer));
